import { render, staticRenderFns } from "./HrTrainLecturer.vue?vue&type=template&id=0bbf234a&scoped=true&"
import script from "./HrTrainLecturer.vue?vue&type=script&lang=js&"
export * from "./HrTrainLecturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf234a",
  null
  
)

export default component.exports